import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Activity, RefreshCw } from "lucide-react";
import { NeuButton } from "../../../components/neu/Neu";
import { NeuTabs } from "../../../components/neu/NeuTabs";
import { SystemDetailDialog } from "./SystemDetailDialog";
import { SystemSection } from "./SystemSection";
import { SYSTEM_KEYS, SYSTEM_SECTIONS, loadsOf } from "./systemSections";
import { useSystemData } from "./useSystemData";

// مراقبة المنصة بتبويبات فرعية: صحة الكود، الأداء، التخزين، الجلسات، الكرون، التنبيهات، الاستهلاك، الجغرافيا.
export const SystemPanel = ({ section = "code", onSection }) => {
  const { t } = useTranslation();
  const [local, setLocal] = useState(section);
  const active = SYSTEM_KEYS.includes(section) ? section : local;
  const { data, busy, load } = useSystemData(loadsOf(active));
  const [detail, setDetail] = useState(null);

  const pick = (key) => {
    setLocal(key);
    onSection?.(key);
  };

  return (
    <div className="grid gap-4" data-testid="system-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-lg font-black">
          <Activity className="h-5 w-5 text-primary" /> {t("system.title")}
        </p>
        <NeuButton className="flex items-center gap-2 text-xs" data-testid="system-refresh" disabled={busy} onClick={load}>
          <RefreshCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} /> {t("system.refresh")}
        </NeuButton>
      </div>

      <NeuTabs
        testid="system-tabs"
        value={active}
        onChange={pick}
        tabs={SYSTEM_SECTIONS.map(({ key, icon }) => ({ key, icon, label: t(`system.tabs.${key}`) }))}
      />

      <div data-testid={`system-section-${active}`}>
        <SystemSection section={active} data={data} open={setDetail} reload={load} />
      </div>

      <SystemDetailDialog section={detail} data={data[detail]} onClose={() => setDetail(null)} onChanged={load} />
    </div>
  );
};
